import { Machine, assign } from 'xstate';
import gql from 'graphql-tag';
import { client } from 'apollo/client';

const STATES = {
  LOADING: 'LOADING',
  UNKNOWN: 'UNKNOWN',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
  EMPTY: 'EMPTY',
};

const EVENTS = {
  PAGE_CHANGE: 'PAGE_CHANGE',
  REFETCH: 'REFETCH',
};

const GET_FREE_TOURS = gql`
  query GET_FREE_TOURS(
    $where: vontravel_tours_bool_exp
    $limit: Int!
    $offset: Int!
    $userId: uuid
    $isLogin: Boolean!
  ) {
   
    list: vontravel_tours(
      limit: $limit
      order_by: { created_at: desc, name: asc }
      offset: $offset
      where: $where
    ) {
      id
      name
      price
      days
      isCharter
      hasGuide
      cover {
        link
      }
      content {
        content
      }
      description {
        content
      }
      features {
        feature {
          id
          name
        }
      }
      users(where: { user_id: { _eq: $userId } }) @include(if: $isLogin) {
        user_id
      }
    }
  }
`;

const tourMachine = Machine(
  {
    context: {
      data: [],
      page: 1,
      pageSize: 12,
      country: null,
      feature: null,
      audience: null,
      userId: null,
    },
    initial: STATES.LOADING,
    states: {
      [STATES.LOADING]: {
        invoke: {
          src: ({ page, pageSize, country, feature, audience, userId }) =>
            client.query({
              query: GET_FREE_TOURS,
              variables: {
                limit: pageSize,
                offset: pageSize * (page - 1),
                where: {
                  country: country && { name: { _eq: country } },
                  features: feature && { feature: { name: { _eq: feature } } },
                  audience: audience && { audience: { name: { _eq: audience } } },
                },
                userId,
                isLogin: Boolean(userId),
              },
            }),
          onDone: {
            target: STATES.UNKNOWN,
            actions: 'assignData',
          },
          onError: STATES.ERROR,
        },
      },
      [STATES.UNKNOWN]: {
        on: {
          '': [
            {
              target: STATES.EMPTY,
              cond: 'isEmpty',
            },
            {
              target: STATES.LOADED,
            },
          ],
        },
      },
      [STATES.LOADED]: {
        on: {
          [EVENTS.PAGE_CHANGE]: {
            target: STATES.LOADING,
            actions: 'changePage',
          },
        },
      },
      [STATES.EMPTY]: {},
      [STATES.ERROR]: {},
    },
    on: {
      [EVENTS.REFETCH]: {
        target: STATES.LOADING,
        actions: 'refetch',
      },
    },
  },
  {
    actions: {
      refetch: () => {},
      changePage: assign({
        page: (_, event) => event.page,
      }),
      assignData: assign({
        data: (context, event) => event.data.data,
      }),
    },
    guards: {
      isEmpty: context => context.data.length === 0,
    },
  }
);

export { tourMachine, STATES as TOUR_STATES, EVENTS as TOUR_EVENTS };
